
import { Outlet } from "react-router-dom";
import Header from "../Components/Frontend/Header";
import Footer from "../Components/Frontend/Footer";

export default function FrontLayout() {

    return (
        <div>
            <Header />

            {/* <main style={{ padding: "20px" }}> */}
            <main >
                <Outlet />
            </main>

            <Footer />
        </div >
    );
}